// material-ui
import { Typography } from '@mui/material';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';

// project imports
import NavHeader from 'layout/shared/Sidebar/MenuList/NavHeader';
import workflowMenu from 'menu-items/workflow';
import MenuPlaceholder from 'layout/shared/Sidebar/Skeleton/MenuPlaceholder';
import { useWorkflowInfo } from 'context/workflow-context';

// ==============================|| WORKFLOW SIDEBAR MENU LIST ||============================== //

const WorkFlowMenuList = () => {
	const { data: workflow, isLoading } = useWorkflowInfo();

	const workflowItem = !isLoading ? workflowMenu(workflow) : {};

	return !isLoading ? (
		<NavHeader title={workflow.workflow_name} item={workflowItem} iconBefore={<DeviceHubIcon />} />
	) : (
		<MenuPlaceholder />
	);
};

export default WorkFlowMenuList;
